//usage: in whatever js file you use this:
//on pageload: var tooltips = new toolTips();
//then, when you need to enable / reenable them: tooltips.init();
//see /views/product/detailsmvc2018.js for working example

var toolTips = function () { 	
	var tooltipTriggers = document.querySelectorAll(".tooltipTrigger"),
	
	toggleToolTip = function(e){        
		if (e.type =='keyup' && (e.which !== 13)) { return;}
		e.preventDefault();
		if(this.nextElementSibling.classList.contains("visible")){ 
			this.nextElementSibling.classList.remove("visible"); 
		}
		else { this.nextElementSibling.classList.add("visible"); }
	},
	
	showToolTip = function(){
		this.nextElementSibling.classList.add("visible");
	},
	
	hideToolTip = function(){
		this.nextElementSibling.classList.remove("visible");
	},
	
	addToggles = function(tooltip){
		tooltip.addEventListener("mousedown", toggleToolTip);
		tooltip.addEventListener("keyup", toggleToolTip);
		tooltip.addEventListener("focus", showToolTip);
		tooltip.addEventListener("blur", hideToolTip);
	},
    
	init = function(){	   
	        var z = tooltipTriggers.length;
	        for(var x = 0; x < z; x++){
	        	addToggles(tooltipTriggers[x]);
	        }
	        // close the tooltip when click outside of it (or on another one)
	        document.addEventListener("click", function(e){
	        	for(var x = 0; x < z; x++){
		        	if(e.target !==  tooltipTriggers[x]){
				        tooltipTriggers[x].nextElementSibling.classList.remove("visible");
			        }
			}
	        });
	};
	
	return {
		init: init
	};
};